// extracted by mini-css-extract-plugin
export default {"base-handle":"BaseHandle_base-handle__cRy22","base-handle-bottom":"BaseHandle_base-handle-bottom__HkuOj"};